// src/router/index.js
import Vue from 'vue'
import VueRouter from 'vue-router'

// 引入组件
import Home from '@/view/home.vue'
import Product from '@/view/M3SERIES.vue'
import About from '@/view/about.vue'
import Contact from '@/view/contact.vue'
import Privacy from '@/view/privacy.vue'
import newProduct from '@/view/newProduct.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'HomePage',
    component: Home
  },
  {
    path: '/M3SERIES',
    name: 'M3SERIES',
    component: Product
  },
  {
    path: '/newProduct',
    name: 'newProduct',
    component: newProduct
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: About
  },
  {
    path:'/contact',
    name:'ContactPage',
    component: Contact
  },
  {
    path:'/privacy',
    name:'Privacy',
    component: Privacy
  },

  // 可以在这里添加更多路由
]

const router = new VueRouter({
  mode: 'hash', // 使用 hash 模式
  base: process.env.BASE_URL,
  routes
})

export default router